import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens } from "./tokens";

/**
 * Panel de sección: superficie blanca con borde fino (sin sombras pesadas),
 * título denso opcional y acciones a la derecha.
 */
export default function SectionPanel({ title, actions, children, sx, contentSx }) {
  return (
    <Box
      sx={{
        bgcolor: tokens.surface,
        border: `1px solid ${tokens.line}`,
        borderRadius: "6px",
        ...sx,
      }}
    >
      {(title || actions) && (
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            px: 2,
            py: 1,
            borderBottom: `1px solid ${tokens.line}`,
            bgcolor: tokens.surface2,
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
          }}
        >
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              color: tokens.ink2,
            }}
          >
            {title}
          </Typography>
          <Box sx={{ flex: 1 }} />
          {actions}
        </Stack>
      )}
      <Box sx={{ p: 2, ...contentSx }}>{children}</Box>
    </Box>
  );
}
